// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router",}[chunkId] || chunkId) + "." + {"144": "7b25844d","264": "3c967e88","282": "d3dd6ae3","31": "600d0a29","354": "76789bd1","466": "4b3f689d","535": "c7723ad3","625": "2af528da","640": "dc859832","662": "ea19636e","689": "ddceee07","728": "435ac13c","787": "d3c925a7","878": "b774d1d2",}[chunkId] + ".js"
}